import {
  ToggleButtonGroup as NovaBaseToggleButtonGroup,
  ToggleButtonGroupProps as NovaToggleButtonGroupProps,
} from '@fme-nova/components'
import {
  ToggleButtonGroup as MuiToggleButtonGroupBase,
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

type ToggleButtonGroupProps = Omit<MuiToggleButtonGroupProps | NovaToggleButtonGroupProps, 'ref'>

const MuiToggleButtonGroup: MsdkStyledComponent<ToggleButtonGroupProps> = styled(MuiToggleButtonGroupBase)`
  border-radius: 8px;
`

const NovaToggleButtonGroup: MsdkStyledComponent<ToggleButtonGroupProps> = styled(NovaBaseToggleButtonGroup)`
  border-radius: 8px;
`

export const ToggleButtonGroup = createComponentWrapperWithRef<ToggleButtonGroupProps>(
  {
    mui: MuiToggleButtonGroup,
    nova: NovaToggleButtonGroup,
  },
  'ToggleButtonGroup',
)
